export class DashboardItem {
    constructor(
        public id: string = "",
        public name: string = "",
        public icon: string = "",
        public route: string = "",
        public description: string = "") {

    }
}